import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/admin", { replace: true });
      return;
    }

    (async () => {
      try {
        // Session exchange happens on the backend — never call Emergent's
        // session-data endpoint from the frontend.
        await axios.post(`${API}/auth/google-session`, { session_id: sessionId }, { withCredentials: true });
        const returnTo = sessionStorage.getItem("auth_return") || "/admin";
        sessionStorage.removeItem("auth_return");
        navigate(returnTo, { replace: true });
      } catch (err) {
        const detail = err.response?.data?.detail;
        toast.error(typeof detail === "string" ? detail : "Google sign-in failed. Please try again.");
        sessionStorage.removeItem("auth_return");
        navigate("/account", { replace: true });
      }
    })();
  }, [hash, navigate]);

  return (
    <div className="min-h-screen bg-ink grid place-items-center font-body" data-testid="auth-callback">
      <p className="font-mono text-xs tracking-[0.2em] text-mist animate-pulse">SIGNING YOU IN…</p>
    </div>
  );
}
